import { Col, Form, Input, InputNumber, Row } from "antd";
import { memo, useEffect } from "react";
import { useIntl } from "react-intl";

const AddAndEditStageForm = ({ stage, handleSetFormRef }) => {
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const initValues = {
    ...stage,
  };

  useEffect(() => {
    handleSetFormRef(form);
  }, []);

  return (
    <Form
      form={form}
      labelCol={{
        span: 11,
      }}
      wrapperCol={{ span: 10 }}
      colon={false}
      labelWrap={true}
      initialValues={initValues}
    >
      <Row>
        <Col span={13}>
          <Form.Item
            required={true}
            name={"nameLocal"}
            label={formatMessage({
              id: "name.local",
              defaultMessage: "Local Name",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.local.name.item",
                defaultMessage: "The name of the {item} in the local Language",
              },
              {
                item: formatMessage({
                  id: "stage",
                  defaultMessage: "Stage",
                }),
              },
            )}
            rules={[
              {
                required: true,
                message: "Please input Local Name",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            labelCol={{
              span: 12,
            }}
            name={"abbreviationLocal"}
            label={formatMessage({
              id: "name.local.abbreviation",
              defaultMessage: "Local Abbr",
            })}
            tooltip={formatMessage({
              id: "form.help.local.abbreviation",
              defaultMessage: "An abbreviation/short name in the local language",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={13}>
          <Form.Item
            name={"nameLatin"}
            label={formatMessage({
              id: "name.latin",
              defaultMessage: "Latin Name",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.latin.name.item",
                defaultMessage: "The name of the {item} in latin characters",
              },
              {
                item: formatMessage({
                  id: "stage",
                  defaultMessage: "Stage",
                }),
              },
            )}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            labelCol={{
              span: 12,
            }}
            name={"abbreviationLatin"}
            label={formatMessage({
              id: "name.latin.abbreviation",
              defaultMessage: "Latin Abbr",
            })}
            tooltip={formatMessage({
              id: "form.help.latin.abbreviation",
              defaultMessage: "An abbreviation/short name in latin characters",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={13}>
          <Form.Item
            name={"externalId"}
            label={formatMessage({
              id: "externalId",
              defaultMessage: "External Id",
            })}
            tooltip={formatMessage({
              id: "externalId",
              defaultMessage: "External Id",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            labelCol={{
              span: 14,
            }}
            required={true}
            rules={[
              {
                required: true,
                message: "Please input Stage Order",
              },
            ]}
            name={"stageOrder"}
            label={formatMessage({
              id: "stage.order",
              defaultMessage: "Stage Order",
            })}
            tooltip={formatMessage({
              id: "form.help.stage.order",
              defaultMessage: "The order in which different stages of a season will play out",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name={"stageCode"} hidden={true} />
        </Col>
      </Row>
    </Form>
  );
};

export default memo(AddAndEditStageForm);
